import { render } from "./TitleColor.vue?vue&type=template&id=46b6bd0e&scoped=true"
import script from "./TitleColor.vue?vue&type=script&lang=js"
export * from "./TitleColor.vue?vue&type=script&lang=js"

import "./TitleColor.vue?vue&type=style&index=0&id=46b6bd0e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b6bd0e"]])

export default __exports__